import React from "react";
import Tippy from "@tippyjs/react";
// import tooltip from 'TooltipTest.module.scss;
import './Tooltip.scss';


const Tooltip = (props) => {
  const { children, content, ...rest} = props;
  return (
    <Tippy
      theme="finto"
      offset={[0, 15]}
      content={content}
      className="tooltip"
      {...rest}
    >
      {children}
    </Tippy>
  );
};

export default Tooltip;
